import { BarcodeScanner } from '@ionic-native/barcode-scanner'
import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/react'
import { qrCodeOutline } from "ionicons/icons"
import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from "react-router"
import { CurrentQuote } from '../components/current.quote'
import { LastScans } from '../components/last.scans'
import Note from "../components/note"
import { Show } from '../components/show'
import { VERSION } from '../config'
import { State } from '../store'
import { addNotification, addNotificationType } from '../store/notification'
import { addMessage, addMessageType } from '../store/peter'

interface StateProps {
  username?: string
}

interface DispatchProps {
  addNotification: addNotificationType
  addMessage: addMessageType
}

type Props = RouteComponentProps<{}> & StateProps & DispatchProps

const Home: React.FC<Props> = (props) => {
  const [showTest, setShowTest] = React.useState(false)

  const scan = async () => {
    console.log('try to scan bill')

    try {
      const result = await BarcodeScanner.scan()

      console.log('read the following data', result)

      const parts = result.text.match(/(\/start\/[^#]+)(#.*)/)

      if (!parts) {
        console.log('invalid url scanned!')
        props.addNotification({
          color: 'warning',
          message: 'Wir verstehen den QR nicht'
        })
        return
      }

      props.history.push({ pathname: parts[1], hash: parts[2] })
    } catch (e) {
      console.error('failed to scan', e)
      props.addNotification({
        color: 'warning',
        message: 'Fehler beim Scan'
      })
    }
  }

  return (
    <IonPage color={'primary'} >
      <IonHeader>
        <IonToolbar color={'primary'}>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false} />
            <img src={'/assets/icon/icon-transparent.png'} alt={'Fertigteilhausversicherung'} height={50} />
          </IonButtons>
          <IonTitle>
            Fertigteilhausversicherung.at
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent
        className="ion-padding"
        color={'background'}
      >
        <Show app={true}>
          <Note>
            <h1>Willkommen</h1>
            <p>scannen sie den QR Code auf der Beilage zu ihrem Gebäudeplan um fortzufahren</p>
          </Note>
        </Show>

        <Show web={true}>
          <Note>
            <h1>Willkommen</h1>
            <p>Installieren sie doch unsere App um über Vorgänge schneller Informiert zu werden</p>
          </Note>

          <LastScans />

          <Show ios={true}>
            <IonCard style={{'--background': '#FFF'}}>
              <IonCardHeader>
                <IonCardTitle>Kamera App</IonCardTitle>
              </IonCardHeader>

              <IonCardContent>
                Öffnen sie die Kamera APP und zeigen sie auf den QR Code, iOS wird den QR Code erkennen und die passende Webseite öffnen.
              </IonCardContent>
            </IonCard>
          </Show>

          <Show desktop={true} ios={true}>
            <a
              onClick={(e) => {
                e.preventDefault()

                props.addNotification({
                  color: 'danger',
                  message: 'App ist noch nicht öffentlich verfügbar',
                })
              }}
              href={'https://appstore.com/app/apple-store/id1501213044'}
              target={'_blank'}
              rel="noopener noreferrer"
              style={{
                display: 'block',
                textAlign: 'center',
                margin: 50,
              }}
            >
              <img
                src={'/assets/store/appstore.png'}
                alt={'App Store öffnen'}
                style={{
                  maxHeight: 60,
                }}
              />
            </a>
          </Show>

          <Show desktop={true} android={true}>
            <a
              href={'https://play.google.com/store/apps/details?id=at.insureit.fertigteilhaus'}
              target={'_blank'}
              rel="noopener noreferrer"
              style={{
                display: 'block',
                textAlign: 'center',
                margin: 50,
              }}
            >
              <img
                src={'/assets/store/googleplay.png'}
                alt={'Google Play öffnen'}
                style={{
                  maxHeight: 60,
                }}
              />
            </a>
          </Show>
        </Show>

        <Show app={true}>
          <div style={{textAlign: 'center'}}>
            <IonButton
              onClick={scan}
              style={{
                'height': '180px',
                '--padding-start': '20px',
                '--padding-end': '20px'
              }}
            >
              <div style={{
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center'
              }}>
                <IonIcon icon={qrCodeOutline} style={{fontSize: '120px', marginBottom: '10px'}} />
                Jetzt Scannen
              </div>
            </IonButton>
          </div>

          <LastScans />
        </Show>


        <CurrentQuote />

        {showTest && (
          <div style={{
            marginTop: 40,
            paddingLeft: 16,
            paddingTop: 16,
            paddingBottom: 16,
            borderLeft: '8px solid rgba(200,0,0,0.15)'
          }}>
            <h1 style={{marginTop: 0}}>Test Bar Codes</h1>
            <IonButton
              href={'/start/1337-APP-002#kVtoIwckQsBzE16HBQdko03GDk403eyIT9fFxzqL'}
            >
              Michael Schramm - 70973
            </IonButton>

            <IonButton
              href={'/start/1337-MS07-101#LUcDCUjn72O0hMDR4fc710raEj9E5sgeEudLlY4w'}
            >
              Elfride Sorgenfrei - 42593
            </IonButton>
          </div>
        )}
      </IonContent>
      <IonFooter
        onClick={() => {
          setShowTest(true)

          props.addMessage({
            animation: 'greet',
            message: 'Oh, viel Spaß beim Testen!'
          })
        }}
      >
        <IonToolbar
          style={{
            textAlign: 'center',
            paddingLeft: 16,
            paddingRight: 16,
            '--background': '#1A69B9',
            color: '#FFF',
          }}
        >
          &copy; {new Date().getFullYear()}, Version {VERSION}
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default connect<StateProps, DispatchProps, unknown, State>(
  ({auth}) => ({
    username: auth.authenticated ? auth.settings!.username : undefined,
  }),
  {
    addNotification,
    addMessage,
  },
)(Home);
